import Headers from '@/component/Headers';
import RuleContent from '@/component/RuleContent';
import { getShweVaultStatus } from '@/Redux/futures/ShweVault/actions';
import { curShweVaultStatus } from '@/Redux/selector';
import backgroundShweVaultMaster1Img1 from '@assets/web-v3-images/backgroundShweVault-master1.png';
import backgroundShweVaultMaster2Img2 from '@assets/web-v3-images/backgroundShweVault-master2.png';
import backgroundShweVaultImg1 from '@assets/web-v3-images/backgroundShweVault1.png';
import backgroundShweVaultImg2 from '@assets/web-v3-images/backgroundShweVault2.png';
import btnImgLock from '@assets/web-v3-images/btnImgLock.png';
import frameQuickRuleImg from '@assets/web-v3-images/frame-shwe-vault-quick-rule.png';
import imgLock from '@assets/web-v3-images/imgLock.png';
import { Text } from '@radix-ui/themes';
import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import OpenVault from './components/OpenVault/OpenVault';
import RankComparison from './components/popup/RankComparison';

const QuickRule = ({ content }) => {
	const { t, i18n } = useTranslation()

	return (
		<div
			className="relative w-full aspect-[1080/580] mb-5 mt-4"
			style={{
				backgroundImage: `url(${frameQuickRuleImg})`,
				backgroundRepeat: 'no-repeat',
				backgroundPosition: 'top center',
				backgroundSize: '100% 100%',
			}}
		>
			<Text className={`absolute left-1/2 top-[8%] -translate-x-1/2 -translate-y-1/2 ${i18n.language === 'my' ? 'text-[13px] sm:text-[24px]' : 'text-[15px] sm:text-[25px]'} font-bold text-[#7A2E0E]`}>
				{t('shwe_vault.quick_rule')}
			</Text>
			<div
				className="
					absolute
					left-[5%]
					right-[18%]
					top-[55%]
					-translate-y-1/2
					h-[70%]
					flex
					items-center
  			"
			>
				<div
					className="w-[75%] max-h-full overflow-y-auto pr-2 hide-scrollbar scrollbar-h-2
										scrollbar-thin
										scrollbar-thumb-[#E6B97D]
										scrollbar-track-transparent"
				>
					<RuleContent
						content={content || ''}
						className="text-left text-[#542314] text-[14px] md:text-[23px] font-medium"
					/>
				</div>
			</div>
		</div>
	);
};

const Numberkeys = ({ count, setCount }) => {
	return (
		<div className="absolute top-[23%] sm:top-[21%] left-[5%]">
			<div
				className="
				absolute
				top-[18%] left-[5%]
				sm:top-[18%] sm:left-[5%]
				md:top-[20%] md:left-[5%]
			"
			>
				<div
					className="
					relative
					w-24 h-8
					sm:w-24 sm:h-8
					md:w-28 md:h-9
					lg:w-30 lg:h-10
					p-2 lg:p-5
					rounded-2xl lg:rounded-3xl
					border-[3px] border-transparent
				"
					style={{
						background: `
						linear-gradient(
							180deg,
							rgba(253,220,174,1),
							rgba(255,255,255,1),
							rgba(255,231,205,1)
						) padding-box,
						linear-gradient(
							180deg,
							rgba(255,184,108,1),
							rgba(255,232,208,1),
							rgba(255,216,161,1)
						) border-box
					`,
					}}
				>
					<img
						src={imgLock}
						alt=""
						className="
						absolute
						-top-3 -left-3
						md:-top-3 md:-left-4
						lg:-top-3 lg:-left-5
						w-10 h-10
						md:w-11 md:h-11
						lg:w-13 lg:h-13
					"
					/>

					<span
						className="
						absolute inset-0
						flex items-center justify-center
						font-bold text-[#55160C]
						text-sm
						md:text-base
						lg:text-lg
					"
					>
						{count}
					</span>

					<img
						src={btnImgLock}
						alt=""
						onClick={() => setCount((prev) => prev + 1)}
						className="
						btn-click-active
						absolute
						right-1
						top-1/2
						-translate-y-1/2
						w-6 h-6
						md:w-7 md:h-7
						lg:w-8 lg:h-8
					"
					/>
				</div>
			</div>
		</div>
	)
}

export default function ShweVault() {
	const [value, setValue] = useState(null)
	const [selectedState, setSelectedState] = useState(null)
	const [count, setCount] = useState(1)
	const [openRankComparison, setOpnenRankComparison] = useState(false)
	const dispatch = useDispatch();
	const { t } = useTranslation()

	const { shweVaultStatus, isMaster } = useSelector(curShweVaultStatus);

	useEffect(() => {
		dispatch(getShweVaultStatus({}));
	}, [dispatch]);

	return (
		<div className="flex flex-col min-h-screen">
			<div className='relative aspect-[1072/1066]'
				style={{
					backgroundImage: `url(${shweVaultStatus?.rank === "EXPLORER" ? backgroundShweVaultImg1 : backgroundShweVaultMaster1Img1})`,
					backgroundSize: "100% auto",
					backgroundRepeat: "no-repeat",
					backgroundPosition: "top center",

				}}
			>
				{/* <Numberkeys count={count} setCount={setCount} /> */}
				<div className='pt-4 sm:pt-12'>
					<Headers title={t('shwe_vault.shwe_vault')} iconSizeCustom='!w-8 sm:!w-16' />
				</div>
				<div
					className="absolute left-1/2 top-[55%] -translate-x-1/2 -translate-y-1/2 cursor-pointer"
					onClick={() => setOpnenRankComparison(true)}
				>
					<AnimatePresence mode="wait">
						{value && (
							<motion.img
								key={value}
								src={value}
								className="-[1072/1066] object-contain"
								initial={{ scale: 0 }}
								animate={{ scale: 1 }}
								transition={{
									type: "spring",
									stiffness: 80,
									damping: 10,
								}}
							/>
						)}
					</AnimatePresence>
				</div>
			</div>
			<div className='relative flex-1 px-4 pb-10 -mt-1'
				style={{
					backgroundImage: `url(${shweVaultStatus?.rank === "EXPLORER" ? backgroundShweVaultImg2 : backgroundShweVaultMaster2Img2})`,
					backgroundSize: "cover",
					backgroundRepeat: "no-repeat",
					backgroundPosition: "center",
				}}
			>
				<OpenVault value={value} setValue={setValue} data={shweVaultStatus} />
				<QuickRule content={shweVaultStatus?.quick_rule?.content} />
			</div>

			<RankComparison open={openRankComparison} onOpenChange={setOpnenRankComparison} />
		</div>
	)
}
